export default {
  Restart: () => {
    console.log('Restarting app...');
    location.reload();
  },
};
